export default __webpack_public_path__ + "static/media/Luca_e_Sofia_porte_cle.90f47638.png";